import * as React from "react";
import Async from 'react-select/lib/Async';
import {toJS} from "mobx";

export class AsyncSelect extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    onChange = (option: any) => {
        if (this.props.multi) {
            return this.props.onChange(option.map((v: any) => {
                return {label: v.label, id: v.id};
            }));
        }

        return this.props.onChange(option);
    };

    getValue = (value: any) => {
        if (!value) {
            return null;
        }

        if (!this.props.multi) {
            return toJS(value);
        }

        const options = toJS(value);
        return options.map((v: any) => {
            return {label: v.label, value: v.id, id: v.id};
        });
    };

    render() {
        const { name, multi, placeholder, disabled = false } = this.props;
        const values = this.getValue(this.props.value);
        return React.createElement(Async, {
            isMulti: multi,
            isDisabled: disabled,
            value: values,
            name: name,
            placeholder: placeholder,
            loadOptions: this.props.loadOptions,
            onChange: this.onChange,
            theme: (theme: any) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary25: 'rgba(47,149,69,.25)',
                    primary50: 'rgba(47,149,69,.5)',
                    primary75: 'rgba(47,149,69,.75)',
                    primary: '#2F9545'
                },
                spacing: {
                    ...theme.spacing,
                    controlHeight: 48
                }
            })
        });
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/AsyncSelect.tsx